<template>
    <div class="overview-menu" v-if="menu.menuLevelTwoList.length > 0">
        <span>{{$i18n.locale == 'tc' ? menu.titleTc : ($i18n.locale == 'en' ? menu.titleEn : menu.title)}}</span>
        <div class="overview-submenu">
            <template v-for="(subMenu, index) in menu.menuLevelTwoList">
                <div class="submenu-title" @click="goToSubMenu(menu, subMenu)">{{$i18n.locale == 'tc' ? subMenu.titleTc : ($i18n.locale == 'en' ? subMenu.titleEn : subMenu.title)}}</div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NavMenu",
        props: {
            menu: {
                type: Object,
                default: {
                    title:''
                }
            }
        },
        components: {},
        data() {
            return {}
        },
        computed: {},
        methods: {
            goToSubMenu(menu, subMenu) {
                let sideInfo = {
                    menu: menu,
                    submenu: subMenu
                }
                this.$store.commit(this.$mutation.SIDE_INFO, sideInfo)
                let url = "/" + this.$store.state.sideInfo.menu.id + "_" + this.$store.state.sideInfo.submenu.id
                // console.log("router push " + url)
                this.$router.push(url)
                this.$emit('refresh')
            },
        },
        mounted() {
        }
    };
</script>

<style lang="less" scoped>
    .overview-menu {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        margin-top: 20px;
        font-size: 14px;
        /*background-color: green;*/
    }

    .overview-submenu {
        width: 1000px;
        min-height: 50px;
        table-layout:fixed;
        word-break: break-all;
        word-wrap: break-word;
        /*overflow:hidden;*/
        flex-wrap: wrap;
        border: 1px solid #eee;
        margin-top: 15px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        .submenu-title {
            line-height: 40px;
            /*margin-bottom: 20px;*/
            /*width: 160px;*/
            padding-left: 30px;
            text-align: left;
            min-width: 160px;
            font-size: 12px;
            color: #092377;
            /*text-align: left;*/
        }
        .submenu-title:hover {
            color: #409EFF;
            font-size: 14px;
            cursor: pointer;
        }
    }

</style>
